// Externe Bibliotheken
import React, { Component } from 'react';
import { Navigate } from 'react-router';

// Interne Module
import * as storage from '@/_helper/storage';
import { deleteCookie } from '@/_helper/mapper';

class Index extends Component {
    constructor(props) {
        super(props);
        storage.clear();
    }

    componentDidMount() {
        storage.clear();
        storage.set('logout', true);
        sessionStorage.setItem('logout', true);

        // Delete Autologout Interval
        if (window.$autoLogoutTimeout) {
            clearTimeout(window.$autoLogoutTimeout);
        }

        sessionStorage.removeItem('tabID');
        sessionStorage.removeItem('redirect_page');
        sessionStorage.removeItem('linkOutTrigger');

        deleteCookie('_rebook-success');

        let domain = window.location.hostname;
        if (window.location.hostname.split('.').length > 1) {
            domain =
                window.location.hostname.split('.')[window.location.hostname.split('.').length - 2] +
                '.' +
                window.location.hostname.split('.')[window.location.hostname.split('.').length - 1];
        }
        document.cookie =
            'loggedIn=; expires=' +
            new Date(new Date().getTime() + -1 * 24 * 60 * 60 * 1000) +
            ';domain=' +
            domain +
            ';path=/;secure;SameSite=Strict';
    }

    render() {
        return <Navigate to={'/login'} />;
    }
}

export default Index;
